import React from "react";
import { Scale } from "lucide-react";

export default function PageLoader() {
  return (
    <div className="min-h-[60vh] grid place-items-center bg-background" data-testid="page-loader">
      <div className="flex flex-col items-center gap-3">
        <div className="w-9 h-9 grid place-items-center border border-brand bg-brand/10 animate-pulse">
          <Scale className="w-4 h-4 text-brand" />
        </div>
        <span className="text-xs text-muted-foreground tracking-widest uppercase">Loading</span>
      </div>
    </div>
  );
}
